import { ApiResponse } from "@defs/api-response";
import { IUser } from "@defs/user";
import axios from "axios";
import { getTenantConfig } from "src/utils/tenant";

class AuthService {
  private getKeycloakUserUrl(): string {
    return getTenantConfig().keycloakUserUrl;
  }

  private getKeycloakLogoutUrl(): string {
    return getTenantConfig().keycloakLogoutUrl;
  }

  /**
   * Fetches the current user. Uses existing cookies (withCredentials).
   * On 401, attempts token refresh once and retries before failing.
   * Only returns null or throws when no valid session/tokens are available.
   */
  async fetchUser(): Promise<IUser | null> {
    // const response = await httpClient.get<ApiResponse<IUser>>(this.url, {
    //   headers: {
    //     isLogin: true,
    //   },
    // });

    const requestUrl = this.getKeycloakUserUrl();
    if (process.env.NODE_ENV === "development") {
      console.log("[Leviatano auth.fetchUser] request", {
        requestUrl,
      });
    }
    try {
      const response = await axios.get<ApiResponse<IUser>>(requestUrl, {
        withCredentials: true,
        headers: {
          isAuthBootstrap: true,
        },
      });
      return response.data.data;
    } catch (err: unknown) {
      if (process.env.NODE_ENV === "development" && axios.isAxiosError(err)) {
        console.warn("[Leviatano auth.fetchUser] error", {
          requestUrl,
          status: err.response?.status,
          statusText: err.response?.statusText,
          responseData: err.response?.data,
        });
      }
      throw err;
    }
  }

  logout() {
    localStorage.removeItem("access_token");
    window.location.href = this.getKeycloakLogoutUrl();
  }
}

const authService = new AuthService();
export default authService;
